export const createStaticReducer = <T>(defaultState: T) => {
  return (state: T): T => {
    return state || defaultState;
  };
};
